import { useLink } from "@made-people/grease-link";
import { useTranslate } from "@made-people/grease-translations";
import { useSearchParams } from "react-router";

export const BlogListPagination = ({
  currentPage,
  totalPages,
}: {
  currentPage: number;
  totalPages: number;
}) => {
  const Link = useLink();
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const selectedTag = searchParams.get("tag") ?? "";

  if (totalPages <= 1) {
    return null;
  }

  const createHref = (page: number) => {
    const params = new URLSearchParams();
    params.set("page", String(page));

    if (selectedTag) {
      params.set("tag", selectedTag);
    }

    return `blog?${params.toString()}`;
  };

  const links = [];
  for (let i = 1; i <= totalPages; i++) {
    links.push(
      <Link
        key={i}
        href={createHref(i)}
        aria-current={currentPage === i ? "page" : undefined}
        aria-label={`Page ${i}`}
        className={`inline-flex min-h-10 min-w-10 items-center justify-center border px-3 text-body-sm transition-colors ${
          currentPage === i
            ? "border-black bg-black text-white"
            : "border-neutral-300 hover:border-black"
        }`}
      >
        {i}
      </Link>,
    );
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 pt-2 lg:pt-4">
      {currentPage > 1 ? (
        <Link
          href={createHref(currentPage - 1)}
          aria-label={translate("Blog_List_Pagination_Previous")}
          className="inline-flex min-h-10 min-w-10 items-center justify-center border border-neutral-300 px-3 transition-colors hover:border-black"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5L8.25 12l7.5-7.5"
            />
          </svg>
        </Link>
      ) : (
        <span className="inline-flex min-h-10 min-w-10 items-center justify-center border border-neutral-200 px-3 text-neutral-300">
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5L8.25 12l7.5-7.5"
            />
          </svg>
        </span>
      )}
      {links}
      {currentPage < totalPages ? (
        <Link
          href={createHref(currentPage + 1)}
          aria-label={translate("Blog_List_Pagination_Next")}
          className="inline-flex min-h-10 min-w-10 items-center justify-center border border-neutral-300 px-3 transition-colors hover:border-black"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 4.5l7.5 7.5-7.5 7.5"
            />
          </svg>
        </Link>
      ) : (
        <span className="inline-flex min-h-10 min-w-10 items-center justify-center border border-neutral-200 px-3 text-neutral-300">
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 4.5l7.5 7.5-7.5 7.5"
            />
          </svg>
        </span>
      )}
    </div>
  );
};
